<template>
  <details class="rounded-xl bg-gray-50 dark:bg-gray-900/40 px-4 py-3">
    <summary
      class="cursor-pointer text-base font-semibold text-gray-900 dark:text-gray-100"
    >
      {{ title }}
    </summary>
    <div class="mt-3 text-sm text-gray-700 dark:text-gray-300">
      <slot />
    </div>
  </details>
</template>

<script setup lang="ts">
defineProps<{
  title: string;
}>();
</script>
